

window.addEventListener("DOMContentLoaded", () => {


    const btnWrapper = document.querySelector('#add_to_cart_btn_container')

    const onlyDefaultVariant = document.querySelector("[data-fake-id='Template_Wrapper']")

    const minusButton = document.querySelector('.quantity_and_submission .minus_quantity_button');

    const plusButton = document.querySelector('.quantity_and_submission .plus_quantity_button');

    const currentQuantityVisible = document.querySelector('.quantity_and_submission input.cart_current_quantity');

    /*  console.log(currentQuantityVisible); */
    
    const hiddenInputQuantity = document.querySelector(' input#hidden_product_quantity');


    currentQuantityVisible.value = hiddenInputQuantity.value;



    currentQuantityVisible.addEventListener('change', function () {

        let currentQuantity = parseInt(currentQuantityVisible.value);

        if (currentQuantity < 1) {
            currentQuantity = 1;
        }

        currentQuantityVisible.value = currentQuantity;
        hiddenInputQuantity.value = currentQuantity;

       
    });



    minusButton.addEventListener('click', function () {

        let currentQuantity = parseInt(currentQuantityVisible.value);

        if (currentQuantity > 1) {
            currentQuantity--;
            currentQuantityVisible.value = currentQuantity;
            hiddenInputQuantity.value = currentQuantity;
        }

       
    });

    plusButton.addEventListener('click', function () {

        let currentQuantity = parseInt(currentQuantityVisible.value);

        currentQuantity++;
        currentQuantityVisible.value = currentQuantity;
        hiddenInputQuantity.value = currentQuantity;

       
        
    });





    const cartForm = document.getElementById('cartForm');

    cartForm.addEventListener('submit', function (event) {
        event.preventDefault();

        if (btnWrapper.dataset.pass === "false" && onlyDefaultVariant.dataset.defaultVariant === "false") {

            window.alert("Vous devez selectionner une variante avant d'ajouter au panier ")
            return

        } else {

            Cart.add(cartForm);
        }

    });

})